import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../tools';
import Seguridad from './seguridad.cmpt';
import ContratoMedios from './contrato-medios.cmpt';
import ContratoDatos from './contrato-datos.cmpt';
import LoSentimos from './lo-sentimos.cmpt';
import Bienvenido from '../contrato/bienvenido.cmpt';

const mapState = (state) => {
    return {
        loading: state.global.loading,
        paso: state.contrato.paso
    }
}

const mapDispatch = (dispatch) => {
    return {
        alerta: (sTitulo, sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnCerrar });
		},
        altaHash: (hashOne, hashTwo) => {
            dispatch({ "type": "REGISTRO_HASH", "hashOne": hashOne, "hashTwo": hashTwo});
        },
        setPaso: (paso) => {
            dispatch({ "type": "CONTRATOS_PASO", "paso": paso});
        }
    }
}

class Flujo extends React.Component {
    
    componentWillMount = () => {
        this.props.setPaso(1);
        
        if(this.props.hashOne && this.props.hashOne != "" && this.props.hashTwo && this.props.hashTwo != "") {
            this.props.altaHash(this.props.hashOne, this.props.hashTwo);
        } else {
            this.props.alerta("ERROR", "La liga no puede ser procesada", () => { 
                goTo("login");
                //window.location.href = '/#!/'; 
            });
        }
    }
    
    render() {
        return (
            <div className="content-wrap">
                <div className="container">
                    <div className="ayuda-wrap">
                        <p>¿Tienes duda de cómo utilizar el portal? <a href="">Ver tutorial</a></p>
                    </div>
                    <div className="white-box">
                        { this.props.paso == 1 &&
                            <div>
                                <div className="pasos-wrap">
                                    <img src={ require("../img/seguridad_activo.svg") } alt="" />
                                </div>
                                <Seguridad />
                            </div>
                        }
						{ this.props.paso == 2 && 
							<ContratoMedios />
						}
						{ this.props.paso == 3 && 
							<ContratoDatos />
						}
						{ this.props.paso == 4 && 
							<LoSentimos />
						}
						{ this.props.paso == 5 && 
							<Bienvenido />
						}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/registro-seguridad/flujo.cmpt.js